var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30751 0.664947C5.56371 0.0489776 6.43629 0.0489768 6.69249 0.664946L7.6756 3.02863C7.78361 3.2883 8.02781 3.46573 8.30816 3.4882L10.8599 3.69278C11.5249 3.74609 11.7946 4.57597 11.2879 5.00997L9.34373 6.67539C9.13014 6.85835 9.03686 7.14543 9.10212 7.419L9.6961 9.90911C9.85089 10.558 9.14495 11.0709 8.57563 10.7232L6.39094 9.38878C6.15093 9.24219 5.84907 9.24219 5.60906 9.38878L3.42437 10.7232C2.85505 11.0709 2.14911 10.558 2.3039 9.90911L2.89788 7.419C2.96314 7.14543 2.86986 6.85835 2.65627 6.67539L0.712072 5.00998C0.205419 4.57597 0.475063 3.74609 1.14005 3.69278L3.69184 3.4882C3.97219 3.46573 4.21639 3.2883 4.3244 3.02863L5.30751 0.664947Z",
    fill: "#F4C950"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.379a8a219fb0ed29b28c22e1455d6c8e.svg";
export { ForwardRef as ReactComponent };